<template>
  <v-app>
    <v-navigation-drawer v-if="menuEnabled" v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
      <v-list dense>
        <template v-for="item in items">
          <v-row v-if="item.heading" :key="item.heading" align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
          </v-row>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon=""
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              link
              :to="{ path: item.path }"
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else :key="item.text" link :to="{ path: item.path }">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar v-if="menuEnabled" :clipped-left="$vuetify.breakpoint.lgAndUp" app color="blue darken-3" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title style="width: 300px;" class="ml-0 pl-4">
        <span class="hidden-sm-and-down">Question editor</span>
      </v-toolbar-title>
      <!-- <v-text-field
        flat
        solo-inverted
        hide-details
        prepend-inner-icon="mdi-magnify"
        label="Search"
        class="hidden-sm-and-down"
      /> -->
      <v-spacer />
      <!-- <v-btn icon>
        <v-icon>mdi-apps</v-icon>
      </v-btn> -->
      <!-- <v-btn icon>
        <v-icon>mdi-bell</v-icon>
      </v-btn> -->
      <!-- <v-btn icon large>
        <v-avatar size="32px" item>
          <v-img
            src="https://cdn.vuetifyjs.com/images/logos/logo.svg"
            alt="Vuetify"
        /></v-avatar>
      </v-btn> -->
      <v-spacer />
      <user></user>
    </v-app-bar>
    <v-main v-if="menuEnabled">
      <router-view></router-view>
    </v-main>
    <v-main v-else>
      <home-not-logged-in @loggedInEvent="processLogin"></home-not-logged-in>
    </v-main>
  </v-app>
</template>

<script>
  import User from "@/components/User";
  import HomeNotLoggedIn from "@/views/HomeNotLoggedIn";
  export default {
    components: { HomeNotLoggedIn, User },
    props: {
      source: String,
    },
    data: () => ({
      dialog: false,
      drawer: null,
      menuEnabled: false,
      items: [
        // { icon: "mdi-history", text: "Frequently contacted" },
        // { icon: "mdi-content-copy", text: "Duplicates" },
        // {
        //   icon: "mdi-chevron-up",
        //   "icon-alt": "mdi-chevron-down",
        //   text: "Labels",
        //   model: true,
        //   children: [{ icon: "mdi-plus", text: "Create label" }]
        // },
        // {
        //   icon: "mdi-chevron-up",
        //   "icon-alt": "mdi-chevron-down",
        //   text: "More",
        //   model: false,
        //   children: [
        //     { text: "Import" },
        //     { text: "Export" },
        //     { text: "Print" },
        //     { text: "Undo changes" },
        //     { text: "Other contacts" }
        //   ]
        // },
        // { icon: "mdi-settings", text: "Settings" },
        // { icon: "mdi-message", text: "Send feedback" },
        // { icon: "mdi-help-circle", text: "Help" },
        // { icon: "mdi-cellphone-link", text: "App downloads" },
        // { icon: "mdi-keyboard", text: "Go to the old version" }
        { icon: 'mdi-home', text: 'Home', path: '/' },
        { icon: 'mdi-home', text: 'Clients', path: '/clients'},
        // { icon: 'mdi-compass', text: 'Question explorer', path: '/explorer' },
        // { icon: 'mdi-image', text: 'Question flow', path: '/question-flow' },
        // { icon: 'mdi-image', text: 'Question change', path: '/change-question' },
        { icon: 'mdi-image', text: 'Survey', path: '/survey' },
      ],
    }),
    methods: {
      processLogin() {
        this.menuEnabled = true;
      }
    }
  };
</script>
